import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import { Typography, ListItem, ListItemText, Collapse } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    drawer: {
        zIndex: 100,
    },
    drawerPaper: {
        width: 240,
    },
    text: {
        margin: theme.spacing.unit,
    },
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    },
    expandable: {
        fontWeight: 500,
    },
});

class SiteDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            helperIsOpen: props.match.url.indexOf("/item-helpers") === 0,
        };
    }

    handleChange = name => () => {
        const value = this.state[name + 'IsOpen'];
        this.setState({
            [name + 'IsOpen']: !value,
        });
    };

    render() {
        const { classes } = this.props;
        
        return (
            <Drawer variant="permanent" classes={{ paper: classes.drawerPaper }} >
                <Typography component={Link} to="/" variant="title" color="inherit" className={classes.text}>
                    Kitsune Kit
                </Typography>
                <Typography variant="subheading" color="inherit" className={classes.text}>
                    v0.2
                </Typography>
                <Divider />
                <List>
                    <ListItem button component={Link} to="/dice">
                        <ListItemText primary="Dice Roller" />
                    </ListItem>
                </List>
                <Divider />
                <List>
                    <ListItem button component={Link} to="/treasure-generator">
                        <ListItemText primary="Treasure Generator" />
                    </ListItem>
                    <ListItem button onClick={this.handleChange('helper')}>
                        <ListItemText primary="Item Helpers"  classes={{ primary: classes.expandable }} />
                        {this.state.helperIsOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={this.state.helperIsOpen}>
                        <List component="div" disablePadding>
                            <ListItem button component={Link} to="/item-helpers/damage-type">
                                <ListItemText primary="Damage Type" />
                            </ListItem>
                            <ListItem button component={Link} to="/item-helpers/ammunition">
                                <ListItemText primary="Ammunition" />
                            </ListItem>
                            <ListItem button component={Link} to="/item-helpers/armor">
                                <ListItemText primary="Armor" />
                            </ListItem>
                            <ListItem button component={Link} to="/item-helpers/weapon">
                                <ListItemText primary="Weapon" />
                            </ListItem>
                            <ListItem button component={Link} to="/item-helpers/spell">
                                <ListItemText primary="Spell" />
                            </ListItem>
                            <ListItem button component={Link} to="/item-helpers/item-content">
                                <ListItemText primary="Item Content" />
                            </ListItem>
                            <ListItem button component={Link} to="/item-helpers/special-features">
                                <ListItemText primary="Special Features" />
                            </ListItem>
                        </List>
                    </Collapse>
                </List>
                <Divider />
                <List>
                    <ListItem button component={Link} to="/travel-planner">
                        <ListItemText primary="Travel Planner" />
                    </ListItem>
                </List>
            </Drawer>
        );
    }
}

SiteDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SiteDrawer);


// WEBPACK FOOTER //
// ./src/site/SiteDrawer.js